import { useMediaQuery } from 'react-responsive';
export var mobileScreenWidth = 960;
export var useResponsive = function () {
    // Screen Setting
    var isLargeDesktop = useMediaQuery({ query: 'screen and (min-width : 1281px)' });
    var isDesktop = useMediaQuery({ query: "screen and (min-width : ".concat(mobileScreenWidth, "px)") });
    var isMobile = useMediaQuery({ query: "screen and (max-width : ".concat(mobileScreenWidth - 1, "px)") });
    return {
        isLargeDesktop: isLargeDesktop,
        isDesktop: isDesktop,
        isMobile: isMobile,
    };
};
